export enum WidgetName {
  GeoObjectCreation = 'geoObjectCreation',
  GeoObjectForm = 'geoObjectForm',
  Region = 'region',
  Geofence = 'geofence',
  Geopoint = 'geopoint',
  GeopointType = 'geopoint-type',
  WeeklySchedule = 'weekly-schedule',
  FindOrders = 'findOrders',
}
